var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicador(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.03589,
    y: 14.0208,
    width: 9.95008,
    height: 9.95008,
    transform: "rotate(45 7.03589 14.0208)",
    fill: "#DB8E3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0564,
    y: 14.0208,
    width: 9.95008,
    height: 9.95008,
    transform: "rotate(45 21.0564 14.0208)",
    fill: "#DB8E3C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0769,
    y: 14.0208,
    width: 9.95008,
    height: 9.95008,
    transform: "rotate(45 35.0769 14.0208)",
    fill: "#DB8E3C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0205,
    y: 35.0769,
    width: 9.95008,
    height: 9.95008,
    transform: "rotate(-45 14.0205 35.0769)",
    fill: "#DB8E3C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0205,
    y: 7.03589,
    width: 9.95008,
    height: 9.95008,
    transform: "rotate(-45 14.0205 7.03589)",
    fill: "#DB8E3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicador);
export default __webpack_public_path__ + "static/media/indicador.474354bbadf2f73c033e1410e22b956c.svg";
export { ForwardRef as ReactComponent };